// src/redux/slices/editModeSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface EditModeState {
  isEditMode: boolean;
}

const initialState: EditModeState = {
  isEditMode: false,
};

export const editModeSlice = createSlice({
  name: 'editMode',
  initialState,
  reducers: {
    // Toggle edit mode
    toggleEditMode: (state) => {
      state.isEditMode = !state.isEditMode;
    },
  },
});

export const {
  toggleEditMode,
} = editModeSlice.actions;

export default editModeSlice.reducer;
